var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, formatDateString } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
import { filter, get, sortBy, truncate, uniqBy } from 'lodash';
import { CSS_DOTS, PLATFORM_DATE_FORMAT } from '../constants';
import { PersonImage } from './person-image';
import { useMonthNamesShort } from '../hooks/use-month-names-short';
import { useComponentPropsFor } from '../context/component-props-context';
import { LinkedinFilledIconGlyph, DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';
import { Badge } from '../elements/badge';
import { OrganisationCell } from './organisation-cell';
import { useLink } from '../hooks/use-link';
import { useTooltipEffect } from '../hooks/use-tooltip-effect';
var cls = classNames('page-meta');
export var PageMetaDefaultProps = {
  label: 'Written By:',
  photoSize: 50,
  labelWithoutPerson: 'Published:',
  showAllPositions: true,
  showEdited: true,
  alignAuthors: false,
  useTooltip: false,
  showBadge: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    ", "\n    \n  "], ["\n    font-size: ", ";\n    ", "\n    \n  "])), theme.FONT_SIZE(15), function (_a) {
    var hasAsideLabel = _a.hasAsideLabel;
    return hasAsideLabel && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme.UNIT(4));
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text-subtle'), theme.UNIT(2))
});
var NameStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n  "], ["\n    margin: 0 0 ", " 0;\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n  "])), theme.UNIT(1), 18 / 15)
});
var PositionsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n  "], ["\n    margin: 0 0 ", " 0;\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n  "])), theme.UNIT(1), 16 / 15)
});
var PositionStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: 0 0 ", ";\n  "], ["\n    margin: 0 0 ", ";\n  "])), theme.UNIT(1))
});
var IconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    height: 25px;\n    width: 25px;\n    margin-right: ", ";\n  "], ["\n    ", ";\n    height: 25px;\n    width: 25px;\n    margin-right: ", ";\n  "])), theme.FILL(cls.color(), 'secondary'), theme.UNIT(2))
});
var DateStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", "em;\n    ", ";\n    padding-top: ", ";\n    font-weight: 300;\n\n  "], ["\n    font-size: ", "em;\n    ", ";\n    padding-top: ", ";\n    font-weight: 300;\n\n  "])), 16 / 15, CSS_DOTS, theme.UNIT(3))
});
var PersonStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n    \n    ", ",\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n    \n    ", ",\n  "])), theme.UNIT(2), theme.UNIT(3), function (_a) {
    var alignAuthors = _a.alignAuthors;
    return alignAuthors && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      flex-direction: column;\n      gap: ", ";\n    "], ["\n      flex-direction: column;\n      gap: ", ";\n    "])), theme.UNIT(1));
  })
});
var OrganisationsStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    justify-content: flex-start;\n\n  "], ["\n    justify-content: flex-start;\n\n  "])))
});
var DetailsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var PhotoStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-right: ", ";\n    \n  "], ["\n    margin-right: ", ";\n    \n  "])), theme.UNIT(2))
});
var EditedStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-size: 0.9em;\n    font-weight: 300;\n    color: ", ";\n    display: inline-block;\n    padding-left: ", "; \n  "], ["\n    font-size: 0.9em;\n    font-weight: 300;\n    color: ", ";\n    display: inline-block;\n    padding-left: ", "; \n  "])), theme.COLOR('text-mid'), theme.UNIT(2))
});
var FooterStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var BioButtonStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    margin-right: ", ";\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 22px;\n    ", ";\n    color: ", ";\n\n    transition: transform .1s;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n    \n    &:active {\n      transform: scale(.96);\n    }\n  "], ["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    margin-right: ", ";\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 22px;\n    ", ";\n    color: ", ";\n\n    transition: transform .1s;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n    \n    &:active {\n      transform: scale(.96);\n    }\n  "])), theme.UNIT(2), theme.COLOR(cls.color(), 'secondary'), theme.UNIT(0), theme.UNIT(4), theme.FONT_SIZE(13), theme.FILL(cls.color(), 'secondary'), theme.COLOR(cls.color(), 'secondary'))
});
var ButtonIconStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 7px;\n    margin-left: ", ";\n  "], ["\n    width: 7px;\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Person: styled.div.attrs(cls.attr('person'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  Details: styled.div.attrs(cls.attr('details'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  Name: styled.h2.attrs(cls.attr('name'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Positions: styled.ul.attrs(cls.attr('positions'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), PositionsStyles),
  Position: styled.li.attrs(cls.attr('position'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  LinkedinIcon: styled(LinkedinFilledIconGlyph)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Photo: styled(PersonImage)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Date: styled.div.attrs(cls.attr('date'))(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  Edited: styled.span.attrs(cls.attr('edited'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), EditedStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  BioButton: styled.span.attrs(cls.attr('button'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), BioButtonStyles),
  ButtonIcon: styled(DottedChevronRightHeavyIconGlyph)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles),
  Organisations: styled.div.attrs(cls.attr('organisation'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), OrganisationsStyles),
  Organisation: styled(OrganisationCell)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  Badge: styled(Badge)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
export var PageMeta = function (props) {
  var _a = useComponentPropsFor('PageMeta', PageMetaDefaultProps, props),
    className = _a.className,
    children = _a.children,
    label = _a.label,
    labelWithoutPerson = _a.labelWithoutPerson,
    photoSize = _a.photoSize,
    showEdited = _a.showEdited,
    alignAuthors = _a.alignAuthors,
    useTooltip = _a.useTooltip,
    showBadge = _a.showBadge;
  var entity = useEntity(props.entity);
  var organisationCellDirection = alignAuthors ? 'column' : 'row';
  var Link = useLink().Link;
  var published = entity.published,
    edited = entity.edited,
    _b = entity.authors,
    authors = _b === void 0 ? [] : _b,
    _c = entity.people,
    people = _c === void 0 ? [] : _c,
    _d = entity.organisationAuthors,
    organisationAuthors = _d === void 0 ? [] : _d;
  var peopleToShow = uniqBy(__spreadArray(__spreadArray([], __read(authors), false), __read(people), false), 'slug');
  var hasPeople = !!peopleToShow.length || !!organisationAuthors.length;
  var hasOrganisationAuthors = !!organisationAuthors.length;
  var hasAsideLabel = hasPeople || !!published;
  var monthNamesShort = useMonthNamesShort();
  var t = useLang();
  var publishedDate = published && formatDateString(published, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  var editedDate = edited && formatDateString(edited, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  var editedShortDate = edited && formatDateString(edited, t('Do MMM'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  var swallowEvent = function (event) {
    event.stopPropagation();
  };
  useTooltipEffect();
  return React.createElement(My.Container, {
    className: cls.name(className),
    hasAsideLabel: hasAsideLabel
  }, hasAsideLabel && React.createElement(My.Label, null, t(hasPeople ? label : labelWithoutPerson)), hasPeople && peopleToShow.map(function (person) {
    var _a;
    var org = person && person.organisation;
    var hasBio = !!person.bio && ((_a = person === null || person === void 0 ? void 0 : person.bio) === null || _a === void 0 ? void 0 : _a.text) !== '';
    var hasLinkedIn = person && person.linkedin;
    var hasWebsite = !!person.websiteUrl;
    var position = person && person.position;
    var badge = person.isMember && person.role ? truncate(person.role.name, {
      length: 35
    }) : false;
    var hasBadge = !!badge;
    var positions = sortBy(person && person.positions || [], function (position) {
      return position.primary ? 0 : 1;
    });
    var showAllPositions = props.showAllPositions && !!positions.length;
    var positionsToShow = showAllPositions ? positions.map(function (pos) {
      return filter([get(pos, 'positions[0].name', pos.position), pos.organisation && pos.organisation.name]).join(", ");
    }) : [filter([position, org && org.name]).join(", ")];
    var onClick = !!((!hasBio || !useTooltip) && hasWebsite) ? function () {
      window.open(person.websiteUrl);
    } : function () {};
    var tooltipProps = useTooltip && hasBio ? {
      "data-event": "click",
      "data-tip": person.bio && person.bio.html || '',
      "data-html": true
    } : {};
    if (!published && !person) {
      return null;
    }
    return React.createElement(My.Person, {
      key: "meta-people-".concat(person.slug),
      alignAuthors: alignAuthors
    }, React.createElement(My.Photo, {
      size: photoSize,
      entity: person
    }), React.createElement(My.Details, null, React.createElement(My.Name, null, person.name), !!positionsToShow.length && React.createElement(My.Positions, null, positionsToShow.map(function (pos) {
      return React.createElement(My.Position, {
        key: pos
      }, pos);
    }), alignAuthors && React.createElement(My.Footer, __assign({
      onClick: onClick
    }, tooltipProps), hasLinkedIn && React.createElement(Link, {
      onClick: swallowEvent,
      title: t('Linkedin'),
      href: person.linkedin,
      target: "_blank"
    }, React.createElement(My.LinkedinIcon, {
      size: 6
    })), hasBio && React.createElement(My.BioButton, null, t('Bio'), React.createElement(My.ButtonIcon, null)), showBadge && hasBadge && React.createElement(My.Badge, {
      colors: {
        background: 'grey'
      }
    }, badge)))));
  }), hasOrganisationAuthors && organisationAuthors.map(function (organisation) {
    var _a;
    var logo = (_a = organisation === null || organisation === void 0 ? void 0 : organisation.logo) === null || _a === void 0 ? void 0 : _a.url;
    return React.createElement(My.Organisations, {
      key: "meta-people-".concat(organisation.slug)
    }, React.createElement(My.Organisation, {
      entity: __assign(__assign({}, organisation), {
        openGraph: {
          image: {
            url: logo
          }
        }
      }),
      size: 'link',
      direction: organisationCellDirection,
      showSocials: alignAuthors,
      useTooltip: useTooltip
    }));
  }), published && React.createElement(My.Date, null, publishedDate, showEdited && editedDate && editedDate !== publishedDate && React.createElement(My.Edited, null, "(", t('Edited: '), editedShortDate, ")")), children);
};
// PageMeta.defaultProps = PageMetaDefaultProps;
PageMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35;